import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from "chart.js";


ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const BarChart = () => {
  const data = {
    labels: [
      "Website/Campaign", "Website/Campaign", "Website/Campaign",
      "Website/Campaign", "Website/Campaign", "Website/Campaign", "Website/Campaign"
    ],
    datasets: [
      {
        label: "Views",
        data: [2500, 4200, 1800, 3500, 2300, 3500, 4700],
        backgroundColor: "#CF86BB",
        borderRadius: 10,
        barThickness: "flex"
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        enabled: true, // ❌ Turn off tooltip if you also don't want hover values
      },
      datalabels: {
        display: false, // ⛔ Explicitly disable data labels if plugin is registered
      },
      tooltip: {
        callbacks: {
          label: (context) => `${context.parsed.y.toLocaleString()} views`
        }
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          stepSize: 1000,
          callback: (val) => (val >= 1000 ? val / 1000 + "k" : val)
        },
        grid: { color: "#eee" }
      },
      x: {
        ticks: {
          autoSkip: false,
          maxRotation: 45,
          minRotation: 0
        },
        grid: { display: false }
      }
    }
  };

  return (
    <div className="chart-container">
      <div className="chart-wrapper">
        <Bar data={data} options={options} />
      </div>
    </div>
  );
};

export default BarChart;
